import { NewSite } from 'src/types/sites/sites';

export const getSitesWithNoCoordinates = (sites: NewSite[] | null) => {
  if (!sites?.length) {
    return [];
  }
  const missingDataSites = sites?.filter((item: NewSite) => {
    const { latitude, longitude } = item.location;
    if (latitude && longitude) {
      const latitudeNum = parseFloat(latitude);
      const longitudeNum = parseFloat(longitude);
      return !latitudeNum || !longitudeNum;
    } else {
      return true;
    }
  });
  return missingDataSites;
};
